import { RefreshCw, Upload } from 'lucide-react';

export function ReleaseStatus({ updated }: { updated: boolean }) {
  const Icon = updated ? RefreshCw : Upload;
  return <span className={`release-status ${updated ? 'release-updated' : 'release-uploaded'}`}><Icon size={12} aria-hidden="true" />{updated ? 'Updated' : 'Uploaded'}</span>;
}
